const schema = {
  possibleTypes: {
    Product: ["ExternalProduct", "StandardProduct"],
    Redemption: ["ExternalRedemption", "StandardRedemption"],
  },
};

export default schema;
